export const ICON_NAMESPACE = 'es-components';
//# sourceMappingURL=namespace.js.map
